import { render, staticRenderFns } from "./Proyecto.vue?vue&type=template&id=63aedaf9&"
import script from "./Proyecto.vue?vue&type=script&lang=js&"
export * from "./Proyecto.vue?vue&type=script&lang=js&"
import style0 from "./Proyecto.vue?vue&type=style&index=0&id=63aedaf9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports